import { z } from 'zod'

export const kScoreSchema = z.object({
  score_3m: z.number().nullable(),
  score_6m: z.number().nullable(),
})
